// Home.jsx
import React, {useEffect, useState, useContext, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { useCart,usePromoCodeInput,EventContext,useTimer } from '../CartContext';
import Cart from '../mini-cart';

import { Container, Row, Col, Button, Collapse,ButtonGroup, Spinner, Modal as RBModal } from 'react-bootstrap';//import Tab from 'react-bootstrap/Tab';
//import Tabs from 'react-bootstrap/Tabs';
import Calendar from 'react-calendar'
//import { Button, ButtonGroup, Spinner } from 'react-bootstrap';
import { parse, format } from 'date-fns';

import {FetchEventInfo,checkDates,filterPromo,GetAvailableDates,GetAvailableTimes,GetAvailableTickets,convertTo12HourFormat,GetAddOns,GetPasses,GetLegend,GetServiceFees,getAllInPrice} from '../api-funcs';
import Modal from './PromoModal.js' // Import the Modal component
import FlashModal from './FlashModal.js'
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function Home ({toggleTimer}) {
  const [searchParams] = useSearchParams();
  const urlPromoCode = searchParams.get('promocode'); // Get 'promocode' from URL

  const [isModalOpen, setIsModalOpen] = useState(true);
  const { globalEventId } = useContext(EventContext);
  
  const { promoCodeInput,updatePromoCode,urlPromoCleared,setPromoCodeClosed} = usePromoCodeInput(); // Get the global user input
  const bottomRef = useRef(null);

  useEffect(() => {
    if ((urlPromoCode) && (!promoCodeInput) && (urlPromoCleared === false)) {
      updatePromoCode(globalEventId,urlPromoCode);
      setPromoCodeClosed(1);
    }
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [eventInfo, setEventInfo] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  //const { globalEventId } = useContext(EventContext);
  
  const fetchData = async () => {
    try {
      const data = await FetchEventInfo(globalEventId);
      setEventInfo(data);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array ensures this runs once on mount

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!eventInfo) {
    return <div>No Event Info Available</div>;
  }

  return (
      <>
          <EventInfo eventInfo={eventInfo}></EventInfo>
          {/*<PageTabs toggleTimer={toggleTimer}></PageTabs>*/}
          <ShowCalendar toggleTimer={toggleTimer} eventStartDate={eventInfo.START_DATE} eventEndDate={eventInfo.END_DATE}></ShowCalendar>

          <Modal isOpen={isModalOpen} closeModal={closeModal} />
          <FlashModal></FlashModal>
      </>
  );
}


export function EventInfo({eventInfo}) {
  const { settings } = useContext(EventContext);

  // Build array of only non-null banner images
  const bannerImages = [
    eventInfo.BANNER_IMAGE_1,
    eventInfo.BANNER_IMAGE_2,
    eventInfo.BANNER_IMAGE_3,
  ].filter(Boolean); // removes null/undefined/empty values

  return (
    <Container>
      <Row>
        <Col xs={12} lg={6} className="p-0">
          <div className="mb-3">
          <Carousel 
            autoPlay 
            infiniteLoop 
            showThumbs={false}  // Hide thumbnails
            showArrows={false}  // Hide left/right arrows
            showStatus={false}  // Hide "1 of 3" indicator
            showIndicators={false}  // Hide dots (pagination)
            swipeScrollTolerance={1}
          >
              {bannerImages.map((image, index) => (
                <div key={index}>
                  <img
                    src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${image}`}
                    alt={`Slide ${index + 1}`}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <h3 className="text-body-emphasis text-start">{eventInfo.NAME || 'No Name Available'}</h3>
          <p className="text-secondary text-start">{eventInfo.DESCRIPTION || 'No Description Available'}</p>
          {/*<div className="text-start">
            <small className="d-inline-flex mb-3 px-2 py-1 fw-semibold text-success-emphasis bg-success-subtle border border-success-subtle rounded-2">
              Multiple Dates
            </small>
          </div>*/}
          <div className="text-start mb-1">
            <i className="bi bi-calendar-event"> </i>
            {eventInfo.START_DATE || 'N/A'} - {eventInfo.END_DATE || 'N/A'}
          </div>
          <div className="text-start">
            <i className="bi bi-geo-alt"> </i>
            {eventInfo.LOCATION || 'No Location Available'}
          </div>
          {eventInfo.EVENT_PROMO_TEXT && (
            <div
              className="promo-banner"
              dangerouslySetInnerHTML={{ __html: eventInfo.EVENT_PROMO_TEXT }}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
}

/*export function PageTabs({toggleTimer}) {
  return (
    <>
      <Container className='mt-3'>
        <Tabs
          defaultActiveKey="tickets"
          id="uncontrolled-tab-example"
          className="mb-2"
        >
          <Tab eventKey="tickets" title="Choose Your Tickets">
            <ShowCalendar toggleTimer={toggleTimer}></ShowCalendar>
          </Tab>
          <Tab eventKey="passes" title="Passes">
          <ShowPasses></ShowPasses>
          </Tab>
          <Tab eventKey="addons" title="Add Ons">
            <ShowAddOns></ShowAddOns>
          </Tab>
          <Tab eventKey="info" title="Info">
            Tab content for Contact
          </Tab>

        </Tabs>

      </Container>
    </>
  );
}
*/

export function ShowCalendar({toggleTimer, eventStartDate, eventEndDate}) {
  const { globalEventId } = useContext(EventContext);
  const { settings } = useContext(EventContext);
  const { promoCodeInput,promoCodeFilter } = usePromoCodeInput(); // Get the global user input

  const [selectedDate, setSelectedDate] = useState(null);
  const [times, setTimes] = useState([]);
  const [clearCounts, setClearCounts] = useState(false);

  const [showDates, setData] = useState(null);
  const [dateArray, setDateArray] = useState([]);
  const [error, setError] = useState(null);
  const [legend, setLegend] = useState(null);
  const [selectedDateEmoji, setSelectedDateEmoji] = useState(null);
  const [selectedDateEmojiText, setSelectedDateEmojiText] = useState(null);

  const bottomRef = useRef(null);
  const containerRef = useRef(null);
  const summaryRef = useRef(null);

  //const startDateString = `${eventStartDate}, ${new Date().getFullYear()}`; // Append current year
  //const calStartDate = new Date(startDateString);

  // helper to zero-out the time
  const stripTime = (d) => {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  };

  const year = new Date().getFullYear();

  // parse your "Month Day" strings with the current year
  const start = stripTime(new Date(`${eventStartDate}, ${year}`));
  const today = stripTime(new Date());

  // use the later of start or today
  const calStartDate = today >= start ? today : start;

  const endDateString = `${eventEndDate}, ${new Date().getFullYear()}`; // Append current year
  const calEndDate = new Date(endDateString);

  const updateTimesForDate = async (date) => {
    const availableTimes = await GetAvailableTimes(globalEventId,date,promoCodeInput,promoCodeFilter);
    setTimes(availableTimes);
  };

  const handleDateChange = async (date) => {
    setSelectedDate(date);
    setSelectedTime(null);
    setTimes([]);

    const dateString = date.toISOString().slice(0, 10);
    const matchedDate = Array.isArray(showDates)
      ? showDates.find((item) => item.EVENTDAY.slice(0, 10) === dateString)
      : null;
    setSelectedDateEmoji(matchedDate?.EMOJI || null);

    // Look up the label from the legend using the emoji filename as the key
    const matchedLegend = matchedDate?.EMOJI && Array.isArray(legend)
      ? legend.find((l) => l.EMOJI === matchedDate.EMOJI)
      : null;
    setSelectedDateEmojiText(matchedLegend?.EMOJI_TEXT || null);

    await updateTimesForDate(date);
  };

  const [selectedTime, setSelectedTime] = useState(null);
  
  const handleTimeClick = (time) => {
    setSelectedTime(time);

    //signal the ticket buttons that the selected time has changed.
    if (clearCounts)
      setClearCounts(false);
    else
      setClearCounts(true);

  };

  let timeZone = '';

  // Scroll to time slots when times load after date selection
  useEffect(() => {
    if (times.length > 0 && !selectedTime) {
      if (bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [times]);

  //Get the list of available show dates
  useEffect( () => {
    
    const getData = async () => {
      try {
        const result = await GetAvailableDates(globalEventId,promoCodeInput,promoCodeFilter);  // Call the function, pass parameter if needed
        setData(result); 
      } catch (err) {
        setError(err.message);  // Handle any errors
      }


      try {
          const legendResult = await GetLegend(globalEventId);
          setLegend(legendResult ?? []); 
      } catch (err) {
          console.error('Legend fetch failed, continuing without it:', err.message);
          setLegend([]); // ← don't call setError here
      }
    };

    getData();  // Trigger the async call on component mount

  }, [promoCodeInput,promoCodeFilter]);

  useEffect(() => {
    updateTimesForDate(selectedDate);
  }, [promoCodeInput,promoCodeFilter]);

  useEffect(() => {
    if (showDates && showDates.length > 0) {
      const updatedDateArray = showDates.map(openDate => openDate.EVENTDAY.substring(0, 10));
      setDateArray(updatedDateArray);  // Update state when showDates changes
    }
  },[showDates]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!showDates) {
    return; //<div>Loading...</div>;
  }

  if (showDates.length > 0)
    timeZone = showDates[0].EVENT_TIMEZONE;

  return (
    <>
    <Container ref={containerRef}>
      {/*<Row className='mt-4 p-2 bg-body-secondary'>
        <Col className='header-bar'>
          <h6>General Admission Tickets - Choose Your Date</h6>
          <div className='legend-text'>
          {legend?.map((item, index) => (
            <span key={index}>
              <img
                className='calendar-icon'
                src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${item.EMOJI}`}
                alt={item.EMOJI_TEXT}
              />
              ={item.EMOJI_TEXT}{' '}
            </span>
          ))}
          </div>
        </Col>
      </Row>*/}
      {promoCodeInput ? ( // Show content if promoCodeInput is set
        <Row>
          <PromoSwitch />
        </Row>
      ) : null
      }
      <Row style={{ marginLeft:"1px", marginRight:"1px" }}>
        <div class="section-card">
          <div class="section-header">
            <div class="section-accent"></div>
              <i class="ti ti-calendar-event section-icon" aria-hidden="true"></i>
              <div class="section-title">Choose your date</div>
          </div>
        <Calendar
            locale="en-GB"
            minDate={calStartDate}
            maxDate={calEndDate}
            value={selectedDate}
            defaultActiveStartDate={calStartDate}
            onChange={handleDateChange}
            tileDisabled={(date) => checkDates(date, dateArray)}
            minDetail="month"
            tileContent={({ date, view }) => {
              if (view !== "month") return null; // Only modify month view

              const dateString = date.toISOString().slice(0, 10);

              // Find matching show date
              const showDate = Array.isArray(showDates) 
              ? showDates.find((item) => item.EVENTDAY.slice(0, 10) === dateString) 
              : null;
              
              // If a match is found, display the corresponding emoji
              return showDate && showDate.EMOJI ? (
                <span className="date-badge">
                  <img className='calendar-icon' src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${showDate.EMOJI}`} alt="Slide 1" />
                {/*  {isNaN(parseInt(showDate.EMOJI, 16)) ? '' : String.fromCodePoint(parseInt(showDate.EMOJI, 16))} */}
                </span>
              ) : null;
                }}
        />
        <div className='legend-text'>
          {selectedDateEmoji && selectedDateEmojiText && (
            <span className='legend-pill'>
              <img
                className='calendar-icon'
                src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${selectedDateEmoji}`}
                alt={selectedDateEmojiText}
              />
              {selectedDateEmojiText}
            </span>
          )}
        </div>

        </div>
      </Row>

      {/* Conditionally render ShowTimeSlots and ShowTickets */}
      {selectedDate && (
        <>
        {selectedDate && times.length > 0 && (
          <Row style={{ marginBottom: "20px" }}>
            <ShowTimeSlots inDate={selectedDate} times={times} onTimeSlotChange={handleTimeClick}></ShowTimeSlots>
          </Row>
        )}
      <div ref={bottomRef} />

        </>
      )}
      {selectedTime && (
        <>
          <Row>
            <ShowTickets timeSlot={selectedTime} eventDate={selectedDate} timeZone={timeZone} clearCounts={clearCounts} toggleTimer={toggleTimer} specialEmoji={selectedDateEmoji} specialEmojiText={selectedDateEmojiText} summaryRef={summaryRef}></ShowTickets>
          </Row>
        </>
      )}
      {/*<Row style={{ marginBottom: "80px" }}>
        <Col>
          <ShowPasses/>
        </Col>
      </Row>
      */}
      {selectedTime && (
        <Row>
          <Col>
            <Cart></Cart>
          </Col>
        </Row>
      )}
      </Container>
      </>
  )
}


export function ShowTimeSlots({inDate, times, onTimeSlotChange}) {

  const handleChange = (e) => {
    onTimeSlotChange(e.target.value);  // Notify parent (ShowCalendar) about the change
  };
  
  const formattedTimes = times.map(oneTime => {
    const justTime = oneTime.EVENT_DATE.substring(11,19);
    return convertTo12HourFormat(justTime);
  });

  let formattedDate = format(inDate, 'eeee, MMMM do, yyyy');

  return (
    <>
      <Container className='mt-3'>
      {/*<Row className='mt-0 p-2 bg-body-secondary'>
        <Col className='header-bar'>
          <h6>Choose Your Time</h6>
        </Col>
      </Row>*/}
      <div class="section-card">
        <div class="section-header">
          <div class="section-accent"></div>
          <i class="ti ti-clock section-icon" aria-hidden="true"></i>
          <div class="section-title">Choose your time</div>
        </div>

        <Row className='dateRow w-100 p-0 m-0 justify-content-center bg-white'>
            <Row className='mb-3 mt-2'>
              <Col xs={4}><div className='legend-square bg-danger legend-text'><span className='ps-3'>Sold&nbsp;Out</span></div></Col>
              <Col xs={4}><div className='legend-square bg-warning legend-text'><span className='ps-3'>Limited</span></div></Col>
              <Col xs={4}><div className='legend-square bg-success legend-text'><span className='ps-3'>Available</span></div></Col>
            </Row>
            <Row>
              <Col xs={12}><h6 className='text-start'>{formattedDate}</h6></Col>
            </Row>

            <Row className='pt-2'>
              {formattedTimes.map((time, index) => (
                <Col xs={3} className='p-0 mb-3' key={index}>
                  <Button 
                    className="timeButton" 
                    type="button" 
                    variant={times[index].TICKET_QUANTITY <= 0 
                      ? 'outline-danger' 
                      : times[index].TICKET_QUANTITY < 100 
                      ? 'outline-warning'
                      : 'outline-success'}
                    onClick={handleChange} 
                    value={time}
                    disabled={times[index].TICKET_QUANTITY <= 0}>
                      {times[index].TICKET_QUANTITY <= 0 
                      ? 'Sold Out' : time}
                  </Button>
                </Col>
              ))}
            </Row>

        </Row>
        </div>
      </Container>
    </>
  )
}

export function ShowTickets({timeSlot, eventDate, timeZone, clearCounts,toggleTimer, specialEmoji, specialEmojiText, summaryRef}) {

  const { updateCartContents, globalCartId } = useCart();
  const { globalEventId } = useContext(EventContext);
  const { promoCodeInput, promoCodeFilter } = usePromoCodeInput(); // Get the global user input

  const [ticketData, setData] = useState(null);
  const [error, setError] = useState(null);

  // State to track the quantities for all button groups
  const [quantities, setQuantities] = useState([]); // Array to hold quantities for 3 button groups
  
  //manage the state of the add to cart button
  const [atcButton, setATCButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState({ show: false, onConfirm: null });
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { startTimer } = useTimer();

  const [serviceFees, setServiceFees] = useState([]);

  useEffect(() => {
    async function fetchFees() {
      const res = await GetServiceFees(globalEventId);
      setServiceFees(res || []);
    }
    fetchFees();
  }, [globalEventId]);

  useEffect(() => {
    setQuantities([]);
  }, [clearCounts]);

  //this handles dynamic number of ticket quantities.
  useEffect(() => {
    setQuantities((prev) => {
      let numGroups = ticketData?.length;
      const newQuantities = Array(numGroups).fill(0);
      return prev.length >= numGroups
        ? prev.slice(0, numGroups) // Shrink array if numGroups decreased
        : [...prev, ...newQuantities.slice(prev.length)]; // Expand with zeros
    });
  }, [ticketData]);

  //useEffect after the ticketData loads:
  useEffect(() => {
    if (ticketData && summaryRef?.current) {
      setTimeout(() => {
        const top = summaryRef.current.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: "smooth" });
      }, 100);
    }
  }, [ticketData]);

  // Function to update the quantity of a specific button group
  const updateQuantity = (index, newQuantity) => {
    // Calculate the current total
    const currentTotal = quantities.reduce((sum, qty, i) => sum + (i === index ? newQuantity : qty), 0);

    // Check if the new total exceeds the maximum
    if (currentTotal <= ticketData[0].available_qty) {
      const updatedQuantities = [...quantities];
      updatedQuantities[index] = newQuantity;
      setQuantities(updatedQuantities); // Update the quantity in the state
    }  
  
  };

  /*const updateCartData = async () => {
    setLoading(true);      // show spinner
    setATCButton(true);    // disable button

    try {
      ticketData.forEach((obj, index) => {
        obj.cart_qty = quantities[index];
      });

      // Check if any ticket being added requires a dependency
      const addOnBeingAdded = ticketData.find(
        (t, i) => quantities[i] > 0 && t.requires_ticket_category
      );

      if (addOnBeingAdded) {
        // Check within the same ticketData array for a matching entry ticket being added
        const dependencySatisfied = ticketData.some(
          (t, i) => quantities[i] > 0 && t.ticket_category === addOnBeingAdded.requires_ticket_category
        );

        // Also check existing cart contents as a fallback (for add-ons added after initial purchase)
        const cartDependencySatisfied = (globalCartId.cartContents || []).some(
          (cartItem) => cartItem.ticket_category === addOnBeingAdded.requires_ticket_category && cartItem.cart_qty > 0
        );

        if (!dependencySatisfied && !cartDependencySatisfied) {
          setLoading(false);
          setATCButton(false);
          setConfirmModal({
            show: true,
            onConfirm: () => {
              setConfirmModal({ show: false, onConfirm: null });
              // put whatever should happen on "Continue" here
              // e.g. proceed with the add-to-cart logic you returned from early
            }
          });
          return;
        }
      }
      
      await updateCartContents(globalEventId, ticketData);
      startTimer();
    } catch (err) {
      console.error("Error updating cart:", err);
      // Optionally show error to user
    } finally {
      setLoading(false);   // hide spinner
      setATCButton(true);  // re-enable button if needed
    }
  };*/


const saveCart = async () => {
  try {
    await updateCartContents(globalEventId, ticketData);
    startTimer();
  } catch (err) {
    console.error("Error updating cart:", err);
  } finally {
    setLoading(false);
    setATCButton(true);
  }
};

const updateCartData = async () => {
  setLoading(true);
  setATCButton(true);

  try {
    ticketData.forEach((obj, index) => {
      obj.cart_qty = quantities[index];
    });

    const addOnBeingAdded = ticketData.find(
      (t, i) => quantities[i] > 0 && t.requires_ticket_category
    );

    if (addOnBeingAdded) {
      const dependencySatisfied = ticketData.some(
        (t, i) => quantities[i] > 0 && t.ticket_category === addOnBeingAdded.requires_ticket_category
      );
      const cartDependencySatisfied = (globalCartId.cartContents || []).some(
        (cartItem) => cartItem.ticket_category === addOnBeingAdded.requires_ticket_category && cartItem.cart_qty > 0
      );

      if (!dependencySatisfied && !cartDependencySatisfied) {
        setLoading(false);
        setATCButton(false);
        setShowWarningModal(true);
        return;
      }
    }

    await saveCart();
  } catch (err) {
    console.error("Error updating cart:", err);
    setLoading(false);
    setATCButton(true);
  }
};

  //load all the tickets and store them in the state variable
  useEffect( () => {

      if (!timeSlot || !eventDate) return;
      
      let parsedDate = parse(timeSlot, 'h:mm a', new Date());
    
      // Format the Date object to 24-hour time format
      let formattedTime = format(parsedDate, 'HH:mm');

      //Set the selected time for the selected date
      eventDate.setHours(formattedTime.substring(0,2));
      if (formattedTime.substring(3,5) === '00')
        eventDate.setMinutes(0);
      else
        eventDate.setMinutes(formattedTime.substring(3,5));
      
      const getData = async () => {
        try {
          const result = await GetAvailableTickets(globalEventId,eventDate,timeZone,promoCodeInput,promoCodeFilter);
            setData(result);  
            
        } catch (err) {
            setError(err.message);  // Handle any errors
        }
      };

        getData();  
  }, [timeSlot,promoCodeFilter]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!ticketData) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Container style={{marginBottom:'50px'}}>
      {/*<Row className='mt-2 p-2 bg-body-secondary'>
        <Col className='header-bar'>
          <h6>Choose Your Tickets</h6>
        </Col>
      </Row>*/}
      <div class="section-card">
    <div class="section-header">
      <div class="section-accent"></div>
      <i class="ti ti-ticket section-icon" aria-hidden="true"></i>
      <div class="section-title">Choose your tickets - <span className='ticketTimeslot'>{timeSlot}</span></div>
    </div>

            {/*<p>{timeSlot}</p>*/}
{/*            {ticketData.map(((oneTicket, index) => (
              <QuantityControl
                index={index} 
                quantity={quantities[index]} 
                updateQuantity={updateQuantity} 
                key={oneTicket.name} 
                ticketInfo={oneTicket}
                setATCButton={setATCButton}
                totalQty={quantities}>
              </QuantityControl>
              
            )))}
*/}

{(() => {
  // Get unique groups in TD_GROUP_SORT order, nulls last
  const groups = [
    ...new Set(
      [...ticketData]
        .sort((a, b) => {
          if (a.td_group_sort == null) return 1;
          if (b.td_group_sort == null) return -1;
          return a.td_group_sort - b.td_group_sort;
        })
        .map(t => t.td_group ?? null)
    )
  ];

  return groups.map(group => {
    const groupTickets = ticketData.filter(t => (t.td_group ?? null) === group);
    return (
      <div key={group ?? 'ungrouped'} className="ticket-group-card" style={{ marginBottom: '16px' }}>
        {group && (
          <div className="ticket-group-heading">{group}</div>
        )}
        {groupTickets.map(oneTicket => {
          const index = ticketData.indexOf(oneTicket);
          return (
            <QuantityControl
              key={oneTicket.name}
              index={index}
              quantity={quantities[index]}
              updateQuantity={updateQuantity}
              ticketInfo={oneTicket}
              setATCButton={setATCButton}
              totalQty={quantities}
              serviceFees={serviceFees}
            />
          );
        })}
      </div>
    );
  });
})()}


        </div>
        <Row ref={summaryRef}>
          <Col className='mt-3 mb-5'>
            <Button
              className='btn btn-info btn-atc'
              onClick={updateCartData}
              disabled={atcButton || loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Adding...
                </>
              ) : (
                'Add to Cart'
              )}
            </Button>

          </Col>
        </Row>
      </Container>
      <RBModal show={showWarningModal} onHide={() => setShowWarningModal(false)}>
  <RBModal.Header closeButton>
    <RBModal.Title>Warning</RBModal.Title>
  </RBModal.Header>
  <RBModal.Body>
    This ticket does not grant access to the show. It must be accompanied by a show ticket.
  </RBModal.Body>
  <RBModal.Footer>
    <Button variant="secondary" onClick={() => setShowWarningModal(false)}>
      Cancel
    </Button>
    <Button className='btn btn-info btn-atc' onClick={() => { setShowWarningModal(false); saveCart(); }}>
      Continue Anyway
    </Button>
  </RBModal.Footer>
</RBModal>
      {createPortal(
        <ATCSummaryBar
          selectedDate={eventDate}
          selectedTime={timeSlot}
          specialEmoji={specialEmoji}
          specialEmojiText={specialEmojiText}
          quantities={quantities}
          ticketData={ticketData}
        />,
        document.body
      )}
    </>
  )
}

export function QuantityControl({ index, quantity, updateQuantity, ticketInfo, setATCButton, totalQty, serviceFees = [] }) {
  const maxQuantity = ticketInfo.ticket_qty ?? ticketInfo.available_qty;
  const buttonSum = totalQty.reduce((total, num) => total + num, 0);
  const allInBase  = getAllInPrice(ticketInfo.base_price,  ticketInfo.ticket_type, serviceFees).toFixed(2);
  const allInPromo = getAllInPrice(ticketInfo.promo_price, ticketInfo.ticket_type, serviceFees).toFixed(2);
  const feeAmt = (Number(allInBase) - Number(ticketInfo.base_price)).toFixed(2);
  
  useEffect(() => {
    if (isNaN(quantity)) {
      setATCButton(true); 
    } else if (buttonSum === 0) {
      setATCButton(true); 
    } else {
      setATCButton(false); 
    }
  }, [quantity, buttonSum, setATCButton]); 

  const decreaseQuantity = () => {
    if (quantity > 0) {
      updateQuantity(index, quantity - 1);
      setATCButton(false);
    }
  };

  const increaseQuantity = () => {
    if (quantity < maxQuantity) {
      updateQuantity(index, quantity + 1);
      setATCButton(false);
    }
  };

  const isSoldOut = maxQuantity === 0;

  return (
  <div className="ticket-card">
    <div className="ticket-row">
      <div className="ticket-info">
        <div className="ticket-name" style={ isSoldOut ? { textDecoration: 'line-through', opacity: 0.5 } : {} }>
          {ticketInfo.name}
        </div>
        <div className="ticket-price">
          {isSoldOut ? (
            <span style={{ color: '#E24B4A' }}>Sold Out</span>
          ) : ticketInfo.promo_price > 0 ? (
            <>
              <s style={{ color: '#999', marginRight: '6px' }}>${allInBase}</s>
              <span style={{ color: '#D85A30' }}>${allInPromo}</span>
            </>
          ) : (
            `$${allInBase}`
          )}
          {Number(feeAmt) > 0 && (
     <span className="ticket-fee-note"> (incl. ${feeAmt} fee)</span>
   )}
        </div>
      </div>
      <div className="ticket-counter">
        <button
          className="tc-btn"
          onClick={decreaseQuantity}
          disabled={quantity === 0 || isSoldOut}
        >
          −
        </button>
        <div className="tc-count">{quantity}</div>
        <button
          className="tc-btn"
          onClick={increaseQuantity}
          disabled={isSoldOut}
        >
          +
        </button>
      </div>
    </div>
    {/* Description now sits outside ticket-row, spanning full width */}
    {ticketInfo.description && (
      <div className="ticket-desc">{ticketInfo.description}</div>
    )}
  </div>
);
}
export function ATCSummaryBar({ selectedDate, selectedTime, specialEmoji, specialEmojiText, quantities, ticketData, onAddToCart, loading, disabled, summaryRef }) {
  const { settings } = useContext(EventContext);

  // Total ticket count across all ticket types
  const totalQty = quantities.reduce((sum, q) => sum + (q || 0), 0);

  // Total subtotal price
  const totalPrice = ticketData
    ? ticketData.reduce((sum, ticket, i) => {
        const price = ticket.promo_price > 0 ? ticket.promo_price : ticket.base_price;
        return sum + price * (quantities[i] || 0);
      }, 0)
    : 0;

  // Format the date
  const formattedDate = selectedDate
    ? format(selectedDate, 'EEE, MMM d')
    : '';

  return (
    <div className="atc-summary-bar" ref={summaryRef}>
      <div className="atc-summary-left">
        <div className="atc-summary-details">
          <div className="atc-summary-title">Your Visit</div>
          <div className="atc-summary-datetime">
            {formattedDate}{selectedTime ? ` • ${selectedTime}` : ''}
          </div>
          {specialEmoji && (
            <div className="atc-summary-special">
              <img
                className="atc-summary-emoji-sm"
                src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${specialEmoji}`}
                alt="Special Night"
              />
              &nbsp;{specialEmojiText || 'Special Night'}
            </div>
          )}
        </div>
      </div>
      {/*<div className="atc-summary-middle">
        <div className="atc-summary-qty">{totalQty} {totalQty === 1 ? 'Ticket' : 'Tickets'}</div>
        <div className="atc-summary-price">${totalPrice.toFixed(2)}</div>
        <div className="atc-summary-label">Subtotal</div>
      </div>
      <div className="atc-summary-right">
        <Button
          className="btn atc-summary-btn"
          onClick={onAddToCart}
          disabled={disabled || loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Adding...
            </>
          ) : (
            <>Add to Cart</>
          )}
        </Button>
      </div>*/}
    </div>
  );
}

export function ShowAddOns() {
  const { globalEventId } = useContext(EventContext);

  const { updateCartContents } = useCart();
  const [addOns, setData] = useState(null);
  const [error, setError] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [atcButton, setATCButton] = useState(true);

  //Get the list of available show dates
  useEffect( () => {
    
    const getData = async () => {
      try {
        const result = await GetAddOns(globalEventId); 
        setData(result); 

      } catch (err) {
        setError(err.message);  // Handle any errors
      }
    };

    getData();

  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!addOns) {
    return <div>Loading...</div>;
  }

  // Update input value for a specific row
  const handleInputChange = (index, value) => {
    setInputValues((prev) => ({
      ...prev,
      [index]: value !== undefined ? value : 0, // Use the index as the key
    }));
    setATCButton(false);
  };

  const updateCartData = () => {
    addOns.forEach((obj, index) => {
      obj.cart_qty = inputValues[index]!== undefined ? inputValues[index] : 0;
    });
    updateCartContents(globalEventId,addOns);
    setATCButton(true);
  };

  return (
    <>
      <Row className='mb-3'>
        <Col xs={2}></Col>
        <Col xs={6} className='text-start'><strong>Item</strong></Col>
        <Col xs={2}><strong>Price</strong></Col>
        <Col xs={2}><strong>Qty</strong></Col>
      </Row>

      {addOns.map(((oneAddOn, index) => (
        <AddOnRow key={index} index={index} addOnImage={oneAddOn.image_name} addOnName={oneAddOn.name} addOnDescription={oneAddOn.description} addOnPrice={oneAddOn.base_price} handleInputChange={handleInputChange}>

        </AddOnRow>
        
      )))}

      <Row className='mt-5'>
        <Col className='mt-3 mb-5'>
          <Button className='btn btn-info' onClick={updateCartData} disabled={atcButton}>Add to Cart</Button>
        </Col>
      </Row>

    </>
  )
}

export function AddOnRow({addOnImage,addOnName,addOnDescription,addOnPrice, index, handleInputChange}) {
  return (
    <>
      <Row className='mt-3'>
        <Col xs={2}><img className='addOnImage' src={require(`./${addOnImage}`)} alt="Add-On" />
        </Col>
        <Col xs={6} className='text-start'>{addOnName}<br/>{addOnDescription}</Col>
        <Col xs={2} className='text-end'>${addOnPrice}</Col>
        <Col xs={2}><input type='number' max='99' className='addOnNumInput' onChange={(e) => handleInputChange(index, e.target.value)}></input></Col>
      </Row>
    </>
  )
}

export function ShowPasses() {

  //Get the list of available show dates
  /*useEffect( () => {
    
    const getData = async () => {
      try {
        console.log(globalEventId);
        const result = await GetPasses(globalEventId); 
console.log(result);
        setData(result); 

      } catch (err) {
        setError(err.message);  // Handle any errors
      }
    };

    getData();

  }, []);
  */
 
  const { updateCartContents, globalCartId } = useCart();
  const { globalEventId } = useContext(EventContext);
  const { promoCodeInput, promoCodeFilter } = usePromoCodeInput(); // Get the global user input

  const [ticketData, setData] = useState(null);
  const [error, setError] = useState(null);

  // State to track the quantities for all button groups
  const [quantities, setQuantities] = useState([]); // Array to hold quantities for 3 button groups
  
  //manage the state of the add to cart button
  const [atcButton, setATCButton] = useState(true);
  const [loading, setLoading] = useState(false);

  const { startTimer } = useTimer();

  const [vipOpen, setVipOpen] = useState(false);
  const toggleVip = () => setVipOpen(v => !v);
  const onHeaderKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleVip(); }
  };

  useEffect(() => {
    setQuantities([]);
  }, []);

  //this handles dynamic number of ticket quantities.
  useEffect(() => {
    setQuantities((prev) => {
      let numGroups = ticketData?.length;
      const newQuantities = Array(numGroups).fill(0);
      return prev.length >= numGroups
        ? prev.slice(0, numGroups) // Shrink array if numGroups decreased
        : [...prev, ...newQuantities.slice(prev.length)]; // Expand with zeros
    });
  }, [ticketData]);

  // Function to update the quantity of a specific button group
  const updateQuantity = (index, newQuantity) => {
    // Calculate the current total
    const currentTotal = quantities.reduce((sum, qty, i) => sum + (i === index ? newQuantity : qty), 0);

    // Check if the new total exceeds the maximum
    if (currentTotal <= ticketData[0].available_qty) {
      const updatedQuantities = [...quantities];
      updatedQuantities[index] = newQuantity;
      setQuantities(updatedQuantities); // Update the quantity in the state
    }  
  
  };

const updateCartData = async () => {
  setLoading(true);      // show spinner
  setATCButton(true);    // disable button

  try {
    ticketData.forEach((obj, index) => {
      obj.cart_qty = quantities[index];
    });

    await updateCartContents(globalEventId, ticketData);
    startTimer();
  } catch (err) {
    console.error("Error updating cart:", err);
    // Optionally show error to user
  } finally {
    setLoading(false);   // hide spinner
    setATCButton(true);  // re-enable button if needed
  }
};


  useEffect( () => {
      
      const getData = async () => {
        try {
          const result = await GetPasses(globalEventId); 
            setData(result);  
            
        } catch (err) {
            setError(err.message);  // Handle any errors
        }
      };

        getData();  
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!ticketData) {
    return <div>Loading...</div>;
  }

  return (
    <>
<Container className='p-0'>
  {/* Header row (click to open/close) */}
  <Row
    className='mt-2 p-2 bg-body-secondary'
    role='button'
    tabIndex={0}
    aria-controls='vipRow'
    aria-expanded={vipOpen}
    onClick={toggleVip}
    onKeyDown={onHeaderKey}
    style={{ cursor: 'pointer' }}
  >
    <Col className='header-bar'>
      <h6 className='mb-0'>⏬  Buy VIP Tickets - Come any day, any time  ⏬<br/>(click here)</h6>
    </Col>
  </Row>

  {/* Collapsible content row (closed by default) */}
  <Collapse in={vipOpen}>
    <div id='vipRow'>
      <Row className='m-0'>
        <Col xs={8} md={6} className="text-start text-md-end vip-section">
          {ticketData.map((oneTicket, index) => (
            <QuantityControl
              index={index}
              quantity={quantities[index]}
              updateQuantity={updateQuantity}
              key={oneTicket.name}
              ticketInfo={oneTicket}
              setATCButton={setATCButton}
              totalQty={quantities}
            />
          ))}
        </Col>
        <Col className='text-end text-md-start vip-atc' xs={4} md={6}>
          <Button
            className='btn btn-info btn-atc'
            onClick={updateCartData}
            disabled={atcButton || loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Adding...
              </>
            ) : (
              'Add to Cart'
            )}
          </Button>
        </Col>
      </Row>
    </div>
  </Collapse>

  {/* Optional note row below if needed */}
  {/* <Row>
    <Col className='text-center'>See below for regular, date specific tickets.</Col>
  </Row> */}
</Container>
    </>
  )
}

/*export function PassRow({addOnImage,addOnName,addOnDescription,addOnPrice, index, handleInputChange}) {
  return (
    <>
      <Row>
        <Col xs={2}><img className='addOnImage' src={require(`./${addOnImage}`)} alt="Add-On" />
        </Col>
        <Col xs={6} className='text-start'>{addOnName}<br/>{addOnDescription}</Col>
        <Col xs={2} className='text-end'>${addOnPrice}</Col>
        <Col xs={2}><input type='number' size={2} onChange={(e) => handleInputChange(index, e.target.value)} onInput="this.value=this.value.replace(/[^0-9]/g,'');"></input></Col>
      </Row>
    </>
  )
}
*/
export function PromoSwitch() {
  const { promoCodeFilter,setPromoCodeFilter } = usePromoCodeInput();

  const handleSwitchChange = (event) => {
    const isChecked = event.target.checked; // Get the checked state
    setPromoCodeFilter(isChecked ? 1 : 0); // Set promoCodeFilter to 1 if checked, 0 if unchecked
  };

  return (
    <>
      <Container>
        <Row className='mb-2'>
          <Col>
            <table className='w-100'>
              <tbody>
              <tr>
                <td align='left' width="45%">Filter by Promo Code</td>
                <td align='left'>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={handleSwitchChange}></input>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>
  </>
  )
}
